var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groups"},[_c('ul',{staticClass:"groups__list"},_vm._l((_vm.groups),function(group){return _c('li',{key:group.id,staticClass:"groups__list-item",class:{
        'groups__list-item--active': _vm.checkInSelected(group.id),
      },on:{"click":function($event){return _vm.setSelected(group.id)}}},[_c('ProductImage',{attrs:{"image-link":_vm.resolveAssetUrl(group.image),"name":group.name}}),_c('span',[_vm._v(_vm._s(group.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }